import { useState } from 'react'
import AxiosAgent from '../../api/Agent'
export interface User {
    CompanyCode: string
    Username: string
    Firstname: string
    Lastname: string
    Email: string
    TelephoneNumber: string
    Warehouse: string
    Position: string
}

const useAgent = <T>() => {
    const [isLoading, setLoading] = useState(false)
    const [isUserLoading, setUserLoading] = useState(false)
    const [message, setMessage] = useState('')
    const getUser = async (): Promise<User> => {
        return await AxiosAgent.Requests.get<User>('user/CurrentUser')
    }
    const agent = {
        ARInvoices: {
            list: async () => {
                try {
                    setLoading(true)
                    const user = await getUser()
                    const username = {
                        username: user.Username,
                    }
                    const response = await AxiosAgent.Requests.post<T[]>(
                        'Invoice/ARAgingDashboard',
                        username
                    )

                    if (response.length === 0) {
                        setLoading(false)
                        setMessage('No data available')
                        return response
                    }
                    setLoading(false)
                    return response
                } catch (error) {
                    setLoading(false)
                    setMessage(error as string)
                    // Handle error here
                    //TODO Log error
                }
            },
            isLoading: isLoading,
            message: message,
        },
        ARGridInvoices: {
            list: async (selectedInvoiceRange: number) => {
                try {
                    setLoading(true)
                    const user = await getUser()
                    const params = {
                        username: user.Username,
                        invoiceRange:selectedInvoiceRange
                    }
                    const response = await AxiosAgent.Requests.post<T[]>(
                        'Invoice/ARAgingGrid',
                        params
                    )

                    if (response.length === 0) {
                        setLoading(false)
                        setMessage('No data available')
                        return response
                    }
                    setLoading(false)
                    return response
                } catch (error) {
                    setLoading(false)
                    setMessage(error as string)
                    // Handle error here
                    //TODO Log error
                }
            },
            isLoading: isLoading,
            message: message,
        },
        ARUsers: {
            list: async () => {
                try {
                    setUserLoading(true)
                    const user = await getUser()
                    const username = {
                        username: user.Username,
                    }

                    const response = await AxiosAgent.Requests.post<EmployeeHierarchy>(
                        'Invoice/ARAgingDashboardFilterTree',
                        username
                    )

                    setUserLoading(false)
                    return response
                } catch (error) {
                    setUserLoading(false)
                }
            },
            isLoading: isUserLoading,
        },
    }
    return { agent }
}

export default useAgent
